<template>

    <div class="p-6">
        <div class="sm:flex sm:items-center sm:justify-between">
            <div class="sm:flex sm:space-x-5">
                <div class="flex justify-center">
                    <div
                        class="h-20 w-20 text-xl rounded-full flex items-center justify-center font-medium text-gray-500 bg-gray-200">
                        <span v-if="profileData.initials">{{ profileData.initials }}</span>
                        <icon v-else name="user" size="24"></icon>
                    </div>
                </div>

                <div class="mt-4 text-center sm:mt-0 sm:pt-3 sm:text-left">
                    <div class="sm:flex sm:space-x-3 sm:mb-0 mb-1 items-center">
                        <h3 v-if="profileData.name || profileData.surname" class="font-semibold text-2xl">
                            {{ profileData.name }} {{ profileData.surname }}</h3>
                        <span
                            :class="{'border bg-pink-100 text-pink-800 border-pink-100': profileData.is_archived, 'bg-teal-100 text-teal-800': !profileData.is_archived}"
                            class="inline-block flex-shrink-0 rounded-full px-2 py-0.5 text-xs font-medium">
                                <span v-if="profileData.is_archived">Archived</span>
                                <span v-else>Active</span>
                            </span>
                    </div>
                    <div class="text-gray-900 text-base">{{ profileData.email }}</div>
                </div>
            </div>
            <div class="mt-5 flex justify-center sm:mt-0">
                <options name="partner_customer_profile_options">
                    <template #toggle>
                        <btn type="secondary" icon-name="more" size="small" class="h-full"></btn>
                    </template>
                    <template #items>

                        <modal title="Customer profile" size="small" name="partner_customer_profile_modal">
                            <template #toggle>
                                <options-item title="Manage"></options-item>
                            </template>
                            <template #body>
                                <div class="space-y-6">
                                    <validation-errors :errors="validationErrors"/>
                                    <div class="text-sm text-gray-500">

                                    </div>
                                    <div class="grid gap-x-6 gap-y-4">
                                        <div class="col-span-2 space-y-4">

                                            <div>
                                                <field-label title="Key"/>
                                                <div class="flex justify-between items-center gap-x-4">
                                                    <text-field
                                                        type="text"
                                                        name="key"
                                                        class="w-full"
                                                        :disabled="!profileData.changeIdentifier"
                                                        v-model="profileData.key"
                                                    ></text-field>
                                                    <btn
                                                        @click="profileData.changeIdentifier = !profileData.changeIdentifier"
                                                        type="secondary">
                                                        {{ !profileData.changeIdentifier ? 'Change' : 'Cancel' }}
                                                    </btn>
                                                </div>
                                            </div>

                                            <div class="col-span-2">
                                                <field-label title="Partner"/>
                                                <div class="flex items-center justify-between gap-x-4">
                                                    <a v-if="!profileData.changePartner"
                                                       :href="profileData.partner_url"
                                                       target="_blank"
                                                       class="text-sm text-teal-600 font-semibold"
                                                    >
                                                        {{ partnerChange.currentPartnerFullName }}
                                                    </a>
                                                    <div v-if="profileData.changePartner" class="relative w-full">

                                                        <div class="bg-white relative w-full">
                                                            <div
                                                                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                                <icon name="magnifier-glass" size="16"></icon>
                                                            </div>
                                                            <div>
                                                                <input
                                                                    v-model="partnerChange.searchInput"
                                                                    type="text"
                                                                    name="partner_change_search"
                                                                    id="partner_change_search"
                                                                    class="transition-shadow block w-full pl-9 text-sm border-gray-300 rounded bg-transparent focus:ring-0 focus:border-gray-400 placeholder-gray-400"
                                                                    placeholder="Search by name or email">
                                                            </div>
                                                            <button
                                                                class="absolute right-2 bg-gray-500 bg-opacity-20 py-1 pl-1.5 pr-2 rounded flex items-center justify-center top-1.5 text-gray-500 focus:outline-none hover:bg-opacity-30"
                                                                @click.prevent="clearChangeSearchInput"
                                                            >
                                                                <icon name="close" size="10"></icon>
                                                                <span
                                                                    class="text-xs font-medium ml-0.5">Clear all</span>
                                                            </button>
                                                        </div>

                                                        <div class="absolute bg-white w-full border rounded shadow-sm z-10 divide-y overflow-scroll mt-1"
                                                             style="max-height: 200px;"
                                                             v-if="partnerChange.searchResultPartners.length > 0">
                                                            <div
                                                                v-for="(partner) in partnerChange.searchResultPartners"
                                                                class="cursor-pointer text-sm p-2"
                                                                :class="{'text-sm text-teal-600 font-semibold': partnerChange.changePartnerToId === partner.id}"
                                                                @click="partnerChangeNewSelected(partner)">
                                                                <div class="font-semibold">{{ partner.full_name }}</div>
                                                                <div class="text-gray-500 font-normal">{{ partner.key }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <btn type="secondary"
                                                         @click="profileData.changePartner = !profileData.changePartner">
                                                        {{ !profileData.changePartner ? 'Change' : 'Cancel' }}
                                                    </btn>
                                                </div>
                                            </div>

                                            <text-field label="Email address" v-model="profileData.email"/>
                                            <text-field label="Name" v-model="profileData.name"/>
                                            <text-field label="Last name" v-model="profileData.surname"/>

                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template #footer>
                                <btn type="primary" @click="updateCustomer" :loading="loading.updating_profile">
                                    Update
                                </btn>
                            </template>
                        </modal>

                        <options-divider></options-divider>

                        <modal title="Are you sure?" size="small" name="partner_customer_delete_modal">
                            <template #toggle>
                                <options-item title="Delete"></options-item>
                            </template>
                            <template #body>
                                <div class="space-y-6">
                                    <validation-errors :errors="validationErrors"/>
                                    <div class="text-sm text-gray-500">
                                        Do you really want to delete this customer?<br/>
                                        This process cannot be undone.
                                    </div>
                                    <div class="grid gap-x-6 gap-y-4">
                                        <div class="col-span-2">
                                            <label class="block text-sm mb-1.5">Please type <span
                                                class="font-semibold">DELETE</span>
                                                to confirm.</label>
                                            <text-field v-model="confirmationString"/>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template #footer>
                                <btn type="primary" @click="deleteCustomer" :loading="loading.deleting">
                                    Yes, delete
                                </btn>
                            </template>
                        </modal>
                        <modal title="Are you sure?" size="small" v-if="!profileData.is_archived"
                               name="partner_customer_archive_modal">
                            <template #toggle>
                                <options-item title="Archive"></options-item>
                            </template>
                            <template #body>
                                <div class="space-y-6">
                                    <validation-errors :errors="validationErrors"/>
                                    <div class="text-sm text-gray-500">
                                        Do you really want to archive this customer?
                                    </div>
                                </div>
                            </template>
                            <template #footer>
                                <btn type="primary" @click="archiveCustomer" :loading="loading.archiving">
                                    Yes, archive
                                </btn>
                            </template>
                        </modal>
                        <modal title="Are you sure?" size="small" v-if="profileData.is_archived"
                               name="partner_customer_restore_archived_modal">
                            <template #toggle>
                                <options-item title="Restore archived"></options-item>
                            </template>
                            <template #body>
                                <div class="space-y-6">
                                    <validation-errors :errors="validationErrors"/>
                                    <div class="text-sm text-gray-500">
                                        Do you really want to restore archived customer?
                                    </div>
                                </div>
                            </template>
                            <template #footer>
                                <btn type="primary" @click="restoreArchiveCustomer"
                                     :loading="loading.restoring_archived">
                                    Yes, restore archived
                                </btn>
                            </template>
                        </modal>

                    </template>
                </options>
            </div>
        </div>
    </div>
    <div
        class="grid grid-cols-1 divide-y divide-gray-200 border-t border-gray-200 sm:grid-cols-3 sm:divide-y-0 sm:divide-x">
        <div class="px-6 py-5 grid justify-items-center">
            <div class="flex items-center text-sm text-gray-500">
                <svg class="mr-1.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18"
                     height="18">
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path
                        d="M17 3h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4V1h2v2h6V1h2v2zm3 8H4v8h16v-8zm-5-6H9v2H7V5H4v4h16V5h-3v2h-2V5zm-9 8h2v2H6v-2zm5 0h2v2h-2v-2zm5 0h2v2h-2v-2z"
                        fill="rgba(17,24,39,1)"/>
                </svg>
                <span>Joined on {{ profileData.created_at }}</span>
            </div>
        </div>
        <div class="px-6 py-5 grid justify-items-center">
            <div class="flex items-center text-sm text-gray-500">
                <svg class="mr-1.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18"
                     height="18">
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path
                        d="M12 14v2a6 6 0 0 0-6 6H4a8 8 0 0 1 8-8zm0-1c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm2.595 7.812a3.51 3.51 0 0 1 0-1.623l-.992-.573 1-1.732.992.573A3.496 3.496 0 0 1 17 14.645V13.5h2v1.145c.532.158 1.012.44 1.405.812l.992-.573 1 1.732-.992.573a3.51 3.51 0 0 1 0 1.622l.992.573-1 1.732-.992-.573a3.496 3.496 0 0 1-1.405.812V22.5h-2v-1.145a3.496 3.496 0 0 1-1.405-.812l-.992.573-1-1.732.992-.572zM18 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
                        fill="rgba(17,24,39,1)"/>
                </svg>
                <span>Key: {{ profileData.key }}</span>
            </div>
        </div>
        <div class="px-6 py-5 grid justify-items-center">
            <div class="flex items-center text-sm text-gray-500">
                <svg class="mr-1.5 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18"
                     height="18">
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path
                        d="M1 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H1zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM21.548.784A13.942 13.942 0 0 1 23 7c0 2.233-.523 4.344-1.452 6.216l-1.645-1.196A11.955 11.955 0 0 0 21 7c0-1.792-.393-3.493-1.097-5.02L21.548.784zm-3.302 2.4A9.97 9.97 0 0 1 19 7a9.97 9.97 0 0 1-.754 3.816l-1.677-1.22A7.99 7.99 0 0 0 17 7a7.99 7.99 0 0 0-.43-2.596l1.676-1.22z"
                        fill="rgba(17,24,39,1)"/>
                </svg>
                <span>Partner: <a class="text-teal-600 font-semibold" :href=" profileData.partner_url" target="_blank">{{
                        profileData.partner_name
                    }} {{ profileData.partner_surname }}</a></span>
            </div>
        </div>
    </div>

    <notification
        :show="showNotification"
        :title="notificationTitle"
        :type="notificationType"
        class="mb-20"
        @notificationClosed="this.showNotification = false"
    >
        <template #message>
            {{ notificationMessage }}
        </template>
    </notification>
</template>

<script>
import ValidationErrors from "../../../common/ValidationErrors";
import TextField from "../../../../elements/forms/TextField.vue";

export default {
    name: "ManageCustomerOptions",
    components: {TextField, ValidationErrors},
    props: {
        programId: {
            type: [Number, String],
            required: true
        },
        profileFormData: {
            type: Object,
            required: false,
            default: {
                name: 'Mindaugas',
                surname: 'Mindaugas',
                email: 'Mindaugas',
                identifier: 'Mindaugas',
                changeIdentifier: false,
                changePartner: false,
            }
        }
    },
    data() {
        return {
            changePartner: false,
            showNotification: false,
            notificationType: '',
            notificationTitle: '',
            notificationMessage: '',
            confirmationString: '',
            validationErrors: null,

            loading: {
                archiving: false,
                deleting: false,
                updating_profile: false,
                restoring_archived: false,
                change_partner_search: false,
            },
            profileData: this.profileFormData,
            partnerChange: {
                searchInput: null,
                searchTimer: null,
                searchResultPartners: [],
                changePartnerToId: this.profileFormData.partner_id,
                currentPartnerKey: this.profileFormData.partner_key,
                currentPartnerFullName: this.profileFormData.partner_full_name,
            },
        }
    },
    watch: {
        'partnerChange.searchInput'(searchInput) {
            this.doChangePartnerSearch(searchInput);
        }
    },
    methods: {
        clearChangeSearchInput() {
            this.partnerChange.searchInput = '';
            this.partnerChange.searchResultPartners = '';
        },
        partnerChangeNewSelected(selectedPartner) {
            this.changePartner = true;
            this.partnerChange.changePartnerToId = selectedPartner.id;
            this.partnerChange.currentPartnerFullName = selectedPartner.full_name;
            this.partnerChange.currentPartnerKey = selectedPartner.key;
            this.profileData.changePartner = false;
        },
        doChangePartnerSearch(searchInput) {

            if (searchInput.length < 2) {
                return;
            }

            const self = this;

            clearTimeout(this.partnerChange.searchTimer);
            this.partnerChange.searchTimer = setTimeout(function () {

                self.partnerChange.searchResultPartners = {};

                axios.get(route('app_int.views.partners.index', {'program': self.programId}), {
                    params: {
                        search: searchInput
                    }
                }).then(response => {
                    if (typeof response.data.data === 'object') {
                        self.partnerChange.searchResultPartners = Object.values(response.data.data).slice(0, 5);
                    }
                }).catch(error => {
                    this.validationErrors = error.response?.data?.errors;
                }).finally(() => {
                });
            }, 500);

        },
        updateCustomer() {

            if (this.loading.updating_profile) {
                return;
            }
            this.loading.updating_profile = true;

            axios.post(route('app_int.customer.update', {
                'program': this.programId,
                'customer': this.profileData.id
            }), {
                name: this.profileData.name,
                surname: this.profileData.surname,
                email: this.profileData.email,
                key: this.profileData.key,
                change_identifier: this.profileData.changeIdentifier,
                change_partner: this.changePartner,
                change_partner_to_id: this.partnerChange.changePartnerToId,
            }).then(response => {

                const status = parseInt(response.data.status ?? -1);

                if (status === 1) {

                    if (response.data.customer) {
                        this.profileData = response.data.customer;
                    }

                    this.emitter.emit('modal-off', 'partner_customer_profile_modal');
                    this.showNotification = true;
                    this.notificationTitle = 'Done';
                    this.notificationType = 'success';
                    this.notificationMessage = 'Customer profile updated successfully.';
                } else {
                    this.showNotification = true;
                    this.notificationTitle = 'Error';
                    this.notificationType = 'warning';
                    this.notificationMessage = response.data.error ?? 'Failed to update partner';
                }
            }).catch(error => {
                this.validationErrors = error.response?.data?.errors;
            }).finally(() => {
                this.loading.updating_profile = false;
                this.profileData.changeIdentifier = false;
                this.profileData.changePartner = false;
                this.emitter.emit('hide-options', 'partner_customer_profile_options');
            });
        },
        deleteCustomer() {

            if (this.loading.deleting) {
                return;
            }
            this.loading.deleting = true;

            axios.delete(route('programs.customer.destroy', {'program': this.programId}), {
                data: {
                    key: this.profileData.key,
                    'confirmation_string': this.confirmationString
                }
            }).then(response => {
                if (response.status === 200) {
                    window.location.href = '/programs/' + this.programId + '/referrals'
                }
            }).catch(error => {
                this.validationErrors = error.response?.data?.errors;
            }).finally(() => {
                this.loading.deleting = false;
                this.emitter.emit('hide-options', 'partner_customer_profile_options');
            });
        },
        archiveCustomer() {

            if (this.loading.archiving) {
                return;
            }
            this.loading.archiving = true;

            axios.post(route('app_int.customer.archive', {'program': this.programId}), {
                key: this.profileData.key
            }).then(response => {
                const status = parseInt(response.data.status ?? -1);
                if (status === 1) {
                    this.emitter.emit('modal-off', 'partner_customer_archive_modal');
                    if (response.data.customer) {
                        this.profileData = response.data.customer;
                    }
                }
            }).catch(error => {
                this.validationErrors = error.response?.data?.errors;
            }).finally(() => {
                this.loading.archiving = false;
                this.emitter.emit('hide-options', 'partner_customer_profile_options');
            });
        },
        restoreArchiveCustomer() {

            if (this.loading.restoring_archived) {
                return;
            }
            this.loading.restoring_archived = true;

            axios.post(route('app_int.customer.restore_archived', {'program': this.programId}), {
                key: this.profileData.key
            }).then(response => {
                const status = parseInt(response.data.status ?? -1);
                if (status === 1) {
                    this.emitter.emit('modal-off', 'partner_customer_restore_archived_modal');
                    if (response.data.customer) {
                        this.profileData = response.data.customer;
                    }
                }
            }).catch(error => {
                this.validationErrors = error.response?.data?.errors;
            }).finally(() => {
                this.loading.restoring_archived = false;
                this.emitter.emit('hide-options', 'partner_customer_profile_options');
            });
        }
    }
}
</script>
